/**
 * Remet un fichier recu du serveur a l'utilisateur : le navigateur
 * l'enregistre sous le nom que le serveur a donne. C'est le geste commun
 * a tous les documents produits par le serveur (ADR-0014).
 */
export function enregistrerFichier(contenu: Blob, nomFichier: string): void {
  const url = URL.createObjectURL(contenu);
  const lien = document.createElement('a');
  lien.href = url;
  lien.download = nomFichier;
  document.body.appendChild(lien);
  lien.click();
  lien.remove();
  // L'URL objet retient le blob en memoire tant qu'elle vit.
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
